
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brandId]",
      function () {
        return require("private-next-pages/[brandId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brandId]"])
      });
    }
  